import { Order } from "src/shared/services/interfacev2";

export const useOrderStats = (orders: Order[]) => {
  const total = orders.length;

  const getStatus = (o: Order): string => {
    const txns = o.orders;
    if (!txns || txns.length === 0) return "";
    return txns[txns.length - 1]?.status?.toLowerCase() || "";
  };

  const pending = orders.filter((o) => getStatus(o) === "pending").length;
  const completed = orders.filter((o) => getStatus(o) === "completed").length;
  const cancelled = orders.filter((o) => getStatus(o) === "cancelled").length;

  return { total, pending, completed, cancelled };
};
